var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c("gg-modal", {
    attrs: {
      "is-active": _vm.dialog
    },
    on: {
      close: _vm.close
    },
    scopedSlots: _vm._u([
      {
        key: "toolbar",
        fn: function fn() {
          return [_vm._v(" Edit Cron Job ")]
        },
        proxy: true
      },
      {
        key: "body",
        fn: function fn() {
          return [
            _c("cron-job-form", {
              ref: "cronJobForm",
              attrs: {
                "line-key": _vm.cromJobObj.linekey,
                "beginning-cron": _vm.cromJobObj,
                actions: false
              },
              on: {
                "start-loading": function startLoading($event) {
                  _vm.loading = true
                },
                "end-loading": function endLoading($event) {
                  _vm.loading = false
                },
                "job-updated": _vm.actionCompleted,
                cancel: _vm.close
              }
            })
          ]
        },
        proxy: true
      },
      {
        key: "actions",
        fn: function fn() {
          return [
            _c(
              "gg-btn",
              {
                attrs: {
                  secondary: ""
                },
                on: {
                  click: _vm.close
                }
              },
              [_vm._v("Cancel")]
            ),
            _c(
              "gg-btn",
              {
                attrs: {
                  loading: _vm.loading
                },
                on: {
                  click: _vm.update
                }
              },
              [_vm._v("Update")]
            )
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }